import { useGetRoom, type RoomPhotoInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { Grid, Spinner } from "@chakra-ui/react";
import { CustomCenter } from "./roomFeed.style";

export const RoomFeed = ({ roomIdx, pensionName }: { roomIdx: string; pensionName: string }) => {
    const { data } = useGetRoom<RoomPhotoInfoResponse>({ section: "photos", roomIdx });
    const newGroup = data?.imgList.concat({ imgUrl: pensionName });
    const { isMobile } = MEDIA();

    return data ? (
        <Grid
            as="section"
            p={isMobile ? "0 20px 64px" : "0 0 128px"}
            templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}
            gridGap="24px"
        >
            {newGroup?.map((img) => {
                const isImg = img.imgUrl.includes("http");

                return (
                    <CustomCenter
                        key={img.imgUrl}
                        isImg={isImg}
                        borderRadius="24px"
                        background={`url(${isImg && img.imgUrl}) no-repeat center/cover`}
                    >
                        {!isImg && img.imgUrl}
                    </CustomCenter>
                );
            })}
        </Grid>
    ) : (
        <Spinner />
    );
};
